import { FC, useState } from 'react';
import { useIntl } from 'react-intl';

import { DentalPhotoAlbum } from '@/shared/api/protocol-ts/model/dto_dental_photo_album_pb';
import { getImageSrc } from '@/shared/lib';
import { Timeline } from '@/shared/ui';

import { getAlbumDisplayName } from '@/entities/album';

import { useDentalPhotoReportCard } from '../../hooks';
import { AlbumMediaCountsLabel } from '../AlbumMediaCountsLabel/AlbumMediaCountsLabel';

type DentalPhotoTimelineRowProps = {
  album: DentalPhotoAlbum;
  patientID: string;
  className?: string;
  testID?: string;
};

export const DentalPhotoTimelineRow: FC<DentalPhotoTimelineRowProps> = (
  props,
) => {
  const { album, patientID, className, testID } = props;

  const { formatMessage, formatDate } = useIntl();
  const { handleCardClick } = useDentalPhotoReportCard(patientID);
  // The first asset may be a video without a thumbnail; the row then shows no preview.
  const [isPreviewBroken, setIsPreviewBroken] = useState(false);

  const title =
    getAlbumDisplayName(album.Name) ??
    formatMessage({
      id: 'studyUpload.DentalPhotos',
      defaultMessage: 'Dental Photos',
    });
  const uploadDate = album.Time?.toDate();
  const [coverPhotoID] = album.StudyAssetIDs;

  return (
    <Timeline.Row
      className={className}
      dataComponent="dental-photo-timeline-row"
      time={
        uploadDate ? formatDate(uploadDate, { timeStyle: 'short' }) : undefined
      }
      icon="photo3dBold"
      title={title}
      meta={
        <>
          {uploadDate && formatDate(uploadDate, { dateStyle: 'medium' })}
          {uploadDate && ' · '}
          <AlbumMediaCountsLabel assetIDs={album.StudyAssetIDs} />
        </>
      }
      preview={
        coverPhotoID && !isPreviewBroken
          ? {
              src: getImageSrc(coverPhotoID, 'thumbnail'),
              alt: title,
              light: true,
              onError: () => setIsPreviewBroken(true),
            }
          : undefined
      }
      testID={testID}
      onClick={handleCardClick}
    />
  );
};
